import { FC } from 'react';

export enum ToggleSize {
  Large,
  Small
}

const Toggle: FC<{
  checked: boolean;
  label: string;
  identifier: string;
  size: ToggleSize;
  onChange: () => void;
}> = ({
  checked,
  label,
  identifier,
  size,
  onChange
}: {
  checked: boolean;
  label: string;
  identifier: string;
  size: ToggleSize;
  onChange: () => void;
}) => {
  let toggleSizeClasses = '';
  let toggleTextClasses = '';
  switch (size) {
    case ToggleSize.Large:
      toggleSizeClasses =
        "absolute w-11 h-6 bg-neutral-400 rounded-full peer peer-checked:bg-success-400 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-white after:border after:rounded-full after:h-5 after:w-5 after:transition-all";
      toggleTextClasses =
        'ml-12 px-1 text-sm font-medium text-black dark:text-neutral-500';
      break;
    case ToggleSize.Small:
      toggleSizeClasses =
        "absolute w-7 h-4 bg-neutral-400 rounded-full peer peer-checked:bg-success-400 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-white after:border after:rounded-full after:h-3 after:w-3 after:transition-all";
      toggleTextClasses =
        'ml-7.5 px-1 text-xs font-medium text-black dark:text-neutral-500';
      break;
  }

  return (
    <>
      <label
        htmlFor={identifier}
        className="inline-flex relative items-center cursor-pointer"
      >
        <input
          type="checkbox"
          checked={checked}
          id={identifier}
          className="peer sr-only"
          onChange={onChange}
        />
        <div className={toggleSizeClasses}></div>
        <span className={toggleTextClasses}>{label}</span>
      </label>
    </>
  );
};

export default Toggle;
